import React, { useContext } from 'react'
import { ModalContext } from 'providers/Modal'
import modalStyles from 'styles/modal.module.scss'

const SwitchTo = () => {
  const { setActive } = useContext(ModalContext)
  const switchForm = formId => {
    setActive(formId)
  }
  return (
    <p className={modalStyles.switcher}>
      Already a Member?{' '}
      <a
        data-testid="modal_login"
        href="javascript:void(0)"
        onClick={() => {
          switchForm('login')
        }}
      >
        Login
      </a>
    </p>
  )
}

export default SwitchTo
